import React, { useCallback, useMemo } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';

import { ADJACENT_COURSE_PAUSE_REQUEST_TYPE } from '@courseResume/data/adjacentCoursePauseRequest';
import { COURSE_PAUSE_REQUEST_STATUSES } from '@courseResume/data/coursePauseRequestStatuses';
import { selectedRequestSelector } from '@courseResume/selectors/coursePauseRequest';
import {
  setSelectedRequest,
  setSelectedSbatLecture,
  setSelectedSuperBatch,
} from '@courseResume/store/coursePauseRequest';
import getAdjacentPauseRequest from '@courseResume/utils/getAdjacentPauseRequest';
import styles from './AdjacentCoursePauseRequestButton.module.scss';
import useFilteredCoursePauseRequests from '@courseResume/hooks/useFilteredCoursePauseRequests';

function AdjacentCoursePauseRequestButton({ type }) {
  const { requestType } = useParams();
  const dispatch = useDispatch();
  const selectedRequest = useSelector(selectedRequestSelector);
  const isNext = type === ADJACENT_COURSE_PAUSE_REQUEST_TYPE.next;

  const { data } = useFilteredCoursePauseRequests({
    requestType,
    coursePauseStatus: COURSE_PAUSE_REQUEST_STATUSES.accepted,
  });

  const adjacentRequest = useMemo(() => {
    if (data?.data) {
      return getAdjacentPauseRequest(data?.data, selectedRequest.id, type);
    }
    return null;
  }, [type, data?.data, selectedRequest.id]);

  const handleClick = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(adjacentRequest));
      dispatch(setSelectedSuperBatch(null));
      dispatch(setSelectedSbatLecture(null));
    });
  }, [dispatch, adjacentRequest]);

  return (
    <Tappable
      disabled={!adjacentRequest}
      onClick={handleClick}
      className={classNames('btn btn-inverted', styles.root)}
    >
      {!isNext && (
        <div>
          <Icon name="chevron-left" /> Previous
        </div>
      )}
      {isNext && (
        <div>
          Next <Icon name="chevron-right" />
        </div>
      )}
    </Tappable>
  );
}

export default AdjacentCoursePauseRequestButton;
